import * as tslib_1 from "tslib";
import { env } from '@ivy/fts/envInfo/envInfo';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ajax from './ajax';
import { guid } from '../../utils';
import { isAndroid } from '@ivy/fts/utils';
import { MessageBox } from 'mint-ui';
import { chooseImage, uploadImage } from '@ivy/fts/weixin';
let Leave = class Leave extends Vue {
    constructor() {
        super(...arguments);
        this.stickyTopCopy = 0;
        this.type = '';
        this.multiple = false;
        this.selfLeaves = [];
        this.pickLeaves = [];
        this.showAddLeaveBox = false;
        this.leaveMsg = '';
        this.fadeClass = 'hide-box';
        this.userInfo = {};
        this.likeBtnPress = false;
        this.memId = null;
    }
    get getLikeSrc() {
        return item => {
            return require(`../../images/${item.is_like ? 'liked' : 'like'}.png`);
        };
    }
    get isAndroidPhone() {
        let ok = isAndroid();
        console.log('ok', ok);
        return ok;
    }
    get getHeader() {
        return item => {
            if (item.user.avatar_url) {
                return item.user.avatar_url;
            }
            else {
                return require('../../images/header-icon.jpg');
            }
        };
    }
    get hasSelfLeaveMsgs() {
        return this.selfLeaves.length > 0;
    }
    get hasPickLeaveMsgs() {
        return this.pickLeaves.length > 0;
    }
    get compStyle() {
        return {
            backgroundColor: this.data.bgColor || '#FFFFFF',
        };
    }
    get classes() {
        return (this.leaveMsg + '').trim() ? 'active' : '';
    }
    get pickHeaderStyle() {
        return this.data.navType
            ? `background: ${this.data.bgColor}`
            : `position: sticky; top: ${this.stickyTopCopy ||
                0}px; z-index: 2; background: ${this.data.bgColor}`;
    }
    get formatStr() {
        return str => {
            str = str
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/\n/g, '<br />');
            return str;
        };
    }
    get isSelfMsg() {
        return item => {
            return this.memId && +item.user.mem_id === +this.memId;
        };
    }
    stickyTopChange(newV) {
        console.log('dddd', newV);
        this.stickyTopCopy = newV;
    }
    async created() {
        this.type = env.type;
        await env.init();
        let userInfo = (await env.getInfo()) || {};
        console.log('rrrr', userInfo);
        if (env.type === 'ivydad') {
            this.userInfo = userInfo.userInfo || {};
            this.memId = this.userInfo.memId || null;
        }
        else {
            this.userInfo = userInfo.logined || {};
            this.memId = this.userInfo.user ? this.userInfo.user.id : null;
        }
        this.loadMine();
        this.loadEssence();
    }
    async mounted() {
        document.body.addEventListener('click', this.inputEvent);
    }
    beforeDestory() {
        document.body.removeEventListener('click', this.inputEvent);
    }
    async inputEvent(e) {
        // console.log(e)
        // let target = e.target
        // let tagName = e.target.tagName
        // if (tagName === 'IMG' || tagName === 'SPAN') {
        //   target = target.parentNode
        // }
        // let isAddBtn = target.className.indexOf('add-leave') > -1
        // if (isAddBtn) {
        //   await this.judgeLogin()
        //   this.showAddLeaveBox = true
        //   await this.$nextTick()
        //   let $leaveMsg = this.$el.querySelector(
        //     '#leave-msg'
        //   ) as HTMLTextAreaElement
        //   console.log('$leaveMsg', $leaveMsg)
        //   $leaveMsg.focus()
        // }
    }
    async openWxCamera() {
        await this.openWxImage(['camera']);
    }
    async openWxAlbum() {
        await this.openWxImage(['album']);
    }
    async openWxImage(resourceType) {
        const { localIds } = await chooseImage(1, resourceType);
        const { serverId } = await uploadImage(localIds[0]);
        const { data: { url }, } = await this.$axios.post(`/api/core/user/wechat/downloadMedia`, {
            serverId,
        });
        console.log(url);
        this.saveMsg([url], 2);
    }
    handleChange(e) {
        const files = e.target.files;
        if (!files) {
            return;
        }
        this.uploadFiles(files);
        let input1 = this.$refs['input1'];
        let input2 = this.$refs['input2'];
        input1 && (input1.value = null);
        input1 && (input2.value = null);
    }
    uploadFiles(files) {
        let postFiles = Array.prototype.slice.call(files);
        if (!this.multiple)
            postFiles = postFiles.slice(0, 1);
        if (postFiles.length === 0)
            return;
        postFiles.forEach(file => {
            this.upload(file);
        });
    }
    getName(ext = 'bin') {
        return `${guid()}_${ext}`;
    }
    upload(file) {
        console.log('file', file);
        let formData = new FormData();
        formData.append('file', file);
        this.hideLeaveModal();
        ajax({
            headers: {},
            withCredentials: true,
            file: file,
            filename: 'file',
            action: '/api/mobile/tool/fileUpload',
            onProgress: e => { },
            onSuccess: res => {
                let url = res.url;
                this.saveMsg([url], 2);
            },
            onError: (err, response) => {
                console.log(err);
            },
        });
    }
    async judgeLogin() {
        await env.init();
        const isLogin = await env.getIsLogin();
        if (!isLogin) {
            await env.login();
            return Promise.reject({ ignore: true });
        }
    }
    async loadMine(config = {}) {
        let noloading = { config };
        let requestConfig = {
            disableLoading: true,
        };
        let page_id = this.$route.query.page_id;
        let rule = this.data.sortRule === 'desc' ? 'DESC' : 'ASC';
        let by = this.data.sortBy === 'leaveTime' ? 'create_time' : 'like_count';
        let { data } = await this.$axios.get('/api/mobile/sns/sns2/commentList', {
            params: {
                product_id: page_id,
                product_type: 'micro_page',
                filter: 'mine',
                sort: by,
                sort_value: rule,
                limit: 100,
                includes: 'comment_count,like_count,is_like,comment',
            },
            ...requestConfig,
        });
        this.selfLeaves = data || [];
    }
    async loadEssence(config = {}) {
        let noloading = { config };
        let requestConfig = {
            disableLoading: true,
        };
        let page_id = this.$route.query.page_id;
        let rule = this.data.sortRule === 'desc' ? 'DESC' : 'ASC';
        let by = this.data.sortBy === 'leaveTime' ? 'create_time' : 'like_count';
        let { data } = await this.$axios.get('/api/mobile/sns/sns2/commentList', {
            params: {
                product_id: page_id,
                product_type: 'micro_page',
                filter: '',
                sort: by,
                sort_value: rule,
                limit: 100,
                includes: 'comment_count,like_count,is_like,comment',
            },
            ...requestConfig,
        });
        this.pickLeaves = data || [];
    }
    async addLeave() {
        await this.judgeLogin();
        this.showAddLeaveBox = true;
        this.fadeClass = 'show-box';
        // await this.$nextTick()
        // let $leaveMsg = this.$el.querySelector('#leave-msg') as HTMLTextAreaElement
        // console.log('$leaveMsg', $leaveMsg)
        // $leaveMsg.focus()
        // setTimeout(() => {
        //   $leaveMsg.focus()
        // }, 200)
    }
    async hideLeaveModal() {
        this.showAddLeaveBox = false;
        this.fadeClass = 'hide-box';
    }
    async saveMsg(con, type = 1) {
        await this.judgeLogin();
        let page_id = this.$route.query.page_id;
        let leaveCon = con || this.leaveMsg.trim();
        if (!leaveCon) {
            return;
        }
        let { data } = await this.$axios.post('/api/mobile/sns/sns2/addComment', {
            product_id: page_id,
            product_type: 'micro_page',
            content: type === 2 ? '' : leaveCon,
            images: type === 2 ? leaveCon : '',
            content_type: type,
        });
        // this.$Toast('留言成功')
        this.leaveMsg = '';
        this.hideLeaveModal();
        console.log(data);
        this.loadMine();
    }
    async delMsg(item) {
        await this.judgeLogin();
        MessageBox.confirm('确定删除该留言?').then(async (action) => {
            console.log('action', action);
            await this.$axios.post('/api/mobile/sns/sns2/delMicroPageComment', {
                id: item.id,
            });
            // this.$Toast('删除留言成功')
            this.loadMine();
            this.loadEssence();
        }, err => {
            console.log(err);
        });
    }
    async likeMsg(item, who) {
        await this.judgeLogin();
        let requestConfig = {
            disableLoading: true,
        };
        if (this.likeBtnPress)
            return;
        this.likeBtnPress = true;
        await this.$axios.get(
        // `/api/goods/shop/market/microPage/${
        //   item.is_like ? 'unLikeComment' : 'likeComment'
        // }`,
        `/api/mobile/sns/sns2/like`, {
            params: {
                product_type: 'comment',
                product_id: item.id,
                type: item.is_like ? 'dislike' : 'like',
            },
            ...requestConfig,
        });
        this.$set(item, 'like_count', item.is_like ? --item.like_count : ++item.like_count);
        this.$set(item, 'is_like', !item.is_like);
        this.selfLeaves = this.selfLeaves.map(_item => {
            if (_item.id === item.id) {
                return item;
            }
            return _item;
        });
        this.pickLeaves = this.pickLeaves.map(_item => {
            if (_item.id === item.id) {
                return item;
            }
            return _item;
        });
        // this.$Toast(item.is_like ? '取消点赞成功' : '点赞成功')
        // await this.loadMine({ noloading: true })
        // await this.loadEssence({ noloading: true })
        this.likeBtnPress = false;
    }
};
tslib_1.__decorate([
    Prop()
], Leave.prototype, "data", void 0);
tslib_1.__decorate([
    Prop({ default: 0 })
], Leave.prototype, "stickyTop", void 0);
tslib_1.__decorate([
    Watch('stickyTop', { immediate: true, deep: true })
], Leave.prototype, "stickyTopChange", null);
Leave = tslib_1.__decorate([
    Component({})
], Leave);
export default Leave;
